import React, { Fragment } from 'react';
import { UFOThirdPartySegment } from '@atlassian/jira-ufo-segment/src/index.tsx';
import type {
	EcosystemModuleProps,
	EcosystemTimeoutViewProps,
} from '@atlassian/jira-connect-utils/src/common/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint, lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

const EcosystemModuleSegment = componentWithFG(
	'issue_add_third_party_ufo_segments',
	UFOThirdPartySegment,
	Fragment,
);

const EcosystemModule = lazyForPaint(
	() => import(/* webpackChunkName: "async-connect-utils-ecosystem-module" */ './index'),
	{ ssr: true, entryFsSsrLiftImportToModule: false },
);

const EcosystemTimeoutView = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-connect-utils-ecosystem-timeout-view" */ './common/ui/ecosystem-timeout-view'
		),
	{ ssr: true, entryFsSsrLiftImportToModule: false },
);

export const EcosystemModuleAsync = (props: EcosystemModuleProps): React.JSX.Element => (
	<EcosystemModuleSegment name="ecosystem-module-async-wrapper" mode="list">
		<Placeholder name="ecosystem-module-async" fallback={<></>}>
			<EcosystemModule {...props} />
		</Placeholder>
	</EcosystemModuleSegment>
);

export const EcosystemTimeoutViewAsync = (props: EcosystemTimeoutViewProps): React.JSX.Element => (
	<EcosystemModuleSegment name="ecosystem-module-timeout-view-wrapper">
		<Placeholder name="ecosystem-timeout-view-async" fallback={<></>}>
			<EcosystemTimeoutView {...props} />
		</Placeholder>
	</EcosystemModuleSegment>
);
